export const MuiCheckbox = (theme) => ({
    styleOverrides: {
        colorSecondary: {
            '&$checked': {
                color: theme.palette.primary.main
            }
        }
    }
});
